import * as React from "react";
import {Loader} from "../../../components/Utils/loader/Loader";

import "./LoadingOvelay.scss";

export class LoadingOverlay extends React.Component<any> {
    public render() {
        return (
            <div className={"loading-overlay"}>
                <Loader/>
            </div>
        );
    }
}
